import type { CaseItem, TargetType } from "../../../packages/core/src/types";

export type MapFilters = { region: string; sort: "published"|"occurred"; query: string; target: TargetType | ""; sex: string; ageMin: string; ageMax: string; from: string; to: string };
export const EMPTY_MAP_FILTERS: MapFilters = { region:"", sort:"published", query: "", target: "", sex: "", ageMin: "", ageMax: "", from: "", to: "" };
const targetTokens: Record<string, TargetType> = { child: "아동", disabled: "지적·자폐성·정신장애인", dementia: "치매환자", adult: "성인" };
const tokenByTarget = Object.fromEntries(Object.entries(targetTokens).map(([token, label]) => [label, token])) as Record<TargetType, string>;

export function parseMapFilters(search: string): MapFilters {
  const params = new URLSearchParams(search);
  const target = targetTokens[params.get("t") ?? ""] ?? "";
  return { region:params.get("region")??"", sort:params.get("sort")==="occurred"?"occurred":"published", query: params.get("q") ?? "", target, sex: params.get("sex") ?? "", ageMin: params.get("ageMin") ?? "", ageMax: params.get("ageMax") ?? "", from: params.get("from") ?? "", to: params.get("to") ?? "" };
}

export function serializeMapFilters(filters: MapFilters, currentSearch = ""): string {
  const params = new URLSearchParams(currentSearch);
  for (const key of ["region", "sort", "q", "t", "sex", "ageMin", "ageMax", "from", "to"]) params.delete(key);
  if(filters.region) params.set("region",filters.region);
  if(filters.sort==="occurred") params.set("sort",filters.sort);
  if (filters.query) params.set("q", filters.query);
  if (filters.target) params.set("t", tokenByTarget[filters.target]);
  if (filters.sex) params.set("sex", filters.sex);
  if (filters.ageMin) params.set("ageMin", filters.ageMin);
  if (filters.ageMax) params.set("ageMax", filters.ageMax);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  const value = params.toString();
  return value ? `?${value}` : "";
}

export function applyMapFilters(items: readonly CaseItem[], filters: MapFilters): CaseItem[] {
  const ageMin = filters.ageMin === "" ? null : Number(filters.ageMin);
  const ageMax = filters.ageMax === "" ? null : Number(filters.ageMax);
  return items.filter((item) => {
    if (filters.region && item.sigunguCode!==filters.region) return false;
    if (filters.query && !item.address.includes(filters.query) && !item.name.includes(filters.query) && item.sigunguCode !== filters.query) return false;
    if (filters.target && item.targetType !== filters.target) return false;
    if (filters.sex && item.sex !== filters.sex) return false;
    if (ageMin !== null && (item.ageNow === null || item.ageNow < ageMin)) return false;
    if (ageMax !== null && (item.ageNow === null || item.ageNow > ageMax)) return false;
    const date = item.occurredAt.slice(0, 10);
    if (filters.from && date < filters.from) return false;
    if (filters.to && date > filters.to) return false;
    return true;
  }).sort((a,b)=>filters.sort==="occurred" ? b.occurredAt.localeCompare(a.occurredAt) : (Date.parse(b.publishedAt??"")||0)-(Date.parse(a.publishedAt??"")||0));
}
